var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "806px",
    height: "824px",
    viewBox: "0 0 806 824",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "F07216D1-019A-406A-BABE-56D090DB0EE4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Back-Office-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.103515625
  }, /*#__PURE__*/React.createElement("g", {
    id: "2-1-2-Sign-in-Option-2",
    transform: "translate(-937.000000, -379.000000)",
    fill: "#FF8421"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(-258.000000, 126.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1598.000000, 665.000000) rotate(-144.000000) translate(-1598.000000, -665.000000) translate(1328.000000, 352.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    points: "393.928218 410.704574 353.441791 625.798083 451.426745 587.9062 471.733314 482.765281"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-3",
    points: "415.686365 158.98974 -7.1299718e-13 314.534726 326.175388 617.672623"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-4",
    points: "211.845214 217.693198 403.317007 144.437525 248.881852 1.90628465e-13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-5",
    points: "93.1140075 258.863835 174.598786 227.38012 111.128358 169.247669"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-6",
    points: "183.620254 214.055752 220.549387 1.01668515e-13 26.5563849 72.0057449"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-7",
    points: "94.5186485 165.833819 78.0421781 256.244877 12.762311 195.704924"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-8",
    points: "392.750863 377.650776 473.707402 346.356326 409.461345 284.325705"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-9",
    points: "422.630706 273.01048 504.841244 241.307419 488.314824 333.300937"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-10",
    points: "431.504884 165.430317 415.686365 257.223092 497.439564 225.278902"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-11",
    points: "452.414362 155.937216 538.78352 121.822869 521.185976 217.693198"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg3);
export default __webpack_public_path__ + "static/media/bg3.fa36ffa4e05386723627e61b61ef6274.svg";
export { ForwardRef as ReactComponent };